import React, { useState } from "react";
import { BASE_URL } from "../../Config/api.config";
import RequestErrorModal from "../RequestErrorPopup";
import Account from "../../assets/img/account.svg";

const Username = ({ state, dispatch, setShowComponent, setAdminData }) => {
  const [warning, setWarning] = useState(false);
  let data = new FormData();
  data.append("mode", "username");
  data.append("username", state.username);

  const checkEmail = () => {
    fetch(`${BASE_URL}login`, {
      method: "POST",
      headers: {},
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "ok") {
          setAdminData((prev) => ({
            ...prev,
            id: data.result.id,
            uid: data.result.token,
          }));
          setShowComponent((prev) => ({
            ...prev,
            user: false,
            password: true,
          }));
        } else {
          setWarning(data.result.error_msg);
          setTimeout(() => {
            setWarning(false);
          }, 3800);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="absolute top-0 left-[50%]">
        <RequestErrorModal warning={warning} />
      </div>
      <div className="relative w-full">
        <img
          src={Account}
          alt="account"
          className="absolute top-[36px] left-4"
        />
        <input
          autoFocus
          type="text"
          value={state.username}
          onChange={(e) =>
            dispatch({
              type: "UPDATE",
              value: e.target.value,
              key: "username",
            })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              checkEmail();
            }
          }}
          className="w-full  outline-none border border-[#ADD8E6] mt-6 rounded h-10 px-12 text-sm"
          placeholder="Username"
        />
      </div>
      <div className="mt-8">
        <button
          type="button"
          //   onClick={() =>
          //     setShowComponent((prev) => ({
          //       ...prev,
          //       user: false,
          //       password: true,
          //     }))
          //   }
          onClick={() => checkEmail()}
          className="px-16 py-1.5 text-white bg-[#2abeeb] hover:bg-[#1d90b3] rounded-full transition duration-300"
        >
          Continue
        </button>
      </div>
    </>
  );
};

export default Username;
